/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import _, { filter } from 'lodash';
import { getRepFilter } from '../../../api/medRepApi';
import useCWPContext from '../context/useCWPContext';

function Filter() {
  const { auth, setFilterForm, filterForm, monthsOptions, searchCwp, clearCwp } =
    useContext(useCWPContext);

  const date = new Date();
  const [repOptions, setRepDrowndown] = useState([]);

  const loadRepDropdown = async () => {
    const year = date.getFullYear().toString();

    const request = {
      department: 'HTAR',
      manager_id: auth.user_id ?? '',
      date_from: `${year}-${filterForm?.month?.value}-01`,
      date_to: `${year}-${filterForm?.month?.value}-31`,
      month: [],
      year: [],
      keyword: '',
    };
    const res = await getRepFilter(request);
    const { code, data } = res.data;

    if (code === '200') {
      const dropdownValue = data?.map((row) => ({
        value: row.rep_id,
        label: row.rep_name,
      }));
      setRepDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  useEffect(() => {
    loadRepDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='kasssar'
            disableClearable
            fullWidth
            options={repOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='HTAR Name' />}
            size='small'
            value={filterForm.kasssar}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'kasssar')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='months'
            disableClearable
            fullWidth
            options={monthsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Months' />}
            size='small'
            value={
              filterForm.month
                ? monthsOptions.find((row) => row.value === filterForm.month.value)
                : null
            }
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'month')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchCwp}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={clearCwp}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
